// On the backend there's some inconsistencies with the colour scheme names as they've changed quite a bit
// These two functions convert the fields into a form that's more consistent for us
// and means we can change all the mappings by amending this one file, instead of changing them everywhere


// To parse a colour scheme received from server
export function convertFromServerColourScheme(serverColourSchemeObject, defaultColor="#FFFFFF") {
    return {
        livestream: serverColourSchemeObject?.livestreamColour || defaultColor,
        hub: serverColourSchemeObject?.hubSpace || defaultColor,
        lounge: serverColourSchemeObject?.openSpace || defaultColor,
        fixed: serverColourSchemeObject?.hybridSpace || defaultColor,
        link: serverColourSchemeObject?.linkColour || defaultColor,
        temporary: serverColourSchemeObject?.digitalSpace || defaultColor,

        primary: serverColourSchemeObject?.primaryColour || defaultColor
    }
}

// To prepare our colour scheme for the server
export function convertToServerColourScheme(ourColourSchemeObject) {
    return {
        livestreamColour: ourColourSchemeObject.livestream,
        hubSpace: ourColourSchemeObject.hub,
        openSpace: ourColourSchemeObject.lounge,
        hybridSpace: ourColourSchemeObject.fixed,
        linkColour: ourColourSchemeObject.link,
        digitalSpace: ourColourSchemeObject.temporary,

        primaryColour: ourColourSchemeObject.primary
    }
}
